<template>
  <CCard>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
        tableFilter
        sorter
        itemsPerPageSelect
      >
        <template #status="{ item }">
          <td>
            <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
          </td>
        </template>
        <template #action="{ item }">
          <td>
            <CButton
              color="info"
              class="px-4 mr-2"
              @click="view(item.Request_ID)"
              >View</CButton
            >
            <!-- <CButton color="primary" class="mr-2" :color="getEdit(item.action)" @click="edit(item.Request_ID)">Edit</CButton>		
          <CButton class="px-4" :color="getDelete(item.action)" @click="deletepop(item.Request_ID)">Delete</CButton> -->
          </td>
        </template>
      </CDataTable>
      <CModal
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        title="Delete"
        size="sm"
        color="dark"
      >
        Are you wan't to delete this?
        <template #header>
          <h6 class="modal-title">Delete</h6>
          <CButtonClose @click="myModal = false" class="text-white" />
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Cancel</CButton>
          <CButton @click="deleteRow" color="success">Delete</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
export default {
  name: "Waste Request List",
  data() {
    return {
      myModal: false,
      plantcodeOptions: [],
    };
  },

  props: {
    items: Array,
    fields: {
      type: Array,
      default() {
        return [
          "Request_ID",
          "Date",
          // "ManifestNo",
          "Site_Name",
          "Waste_Name",
          "Quantity",
          "Vehicle_Type",
          "action",
        ];
      },
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },
  mounted() {},
  computed: {},
  methods: {
    edit(id) {
      console.log("edit " + id);
      this.$router.push({ path: "edit_waste" });
    },
    view(id) {
      localStorage.setItem("waste_view_id", id);
      this.$router.push({ path: "viewWasteRequest" });
    },
    getEdit(color) {
      return "primary";
    },
    getDelete(color) {
      return "danger";
    },
    deletepop(id) {
      $("#del").attr("rowData", id);
      this.myModal = true;
      //alert('call'+id);
    },
    deleteRow() {
      var id = $("#del").attr("rowData");
      console.log("delete " + id);
      this.myModal = false;
    },
    add() {
      console.log("add");
      this.$router.push({ path: "add_waste" });
    },
  },
};
</script>
